import React, {useState} from 'react'
import axios from 'axios'
import {Link} from 'react-router-dom'
import { FloatingLabel, Form, Button, Row, Container, Col } from 'react-bootstrap'
import {FaApple, FaGoogle, FaFacebookF} from 'react-icons/fa'

const styled = {border:"none", outline:"none", boxShadow:"none", width:"100%"}

function Register() {
    const [userInfo, setUserInfo] = useState({})

   const registerUser = async (e) => {
    e.preventDefault()  
    console.log(userInfo)
      const user = {
         fristName: userInfo.fristName,
         password : userInfo.passwoed,
         phone : userInfo.phone,
         mail : userInfo.mail,
         address : userInfo.address,
         zip :userInfo.zip,
       }
       console.log(user)
      await axios.post('http://localhost:5000/app/signup', user).then(res => console.log(res))
       
     }

    return (
        <div>
      <Container className ="h-50 w-100 my-3">
        <h2 className="fw-bold fs-2 my-4 text-center w-100 h-25">Create An Account</h2>
        <Row className="d-flex justify-content-evenly py-5">
      <Col md={5}>
       <Form className="mt-2 d-flex align-items-center justify-content-center flex-wrap" onSubmit={registerUser}>
  <FloatingLabel 
  controlId="floatingInput" 
  label="username"
  className="mb-3 border border-dark d-inline-block w-100">
    <Form.Control 
    style={styled}
    type="text" 
    placeholder="Frist Name" 
    onChange={(e) => setUserInfo({... userInfo, username:e.target.value})}/>
  </FloatingLabel>
  <FloatingLabel 
  controlId="floatingInput" 
  label="Password"
  className="mb-3 border border-dark d-inline-block w-100">
    <Form.Control 
    style={styled}
    type="password" 
    placeholder="Password" onChange={(e) => setUserInfo({... userInfo, passwoed:e.target.value})}/>
  </FloatingLabel>
  <FloatingLabel 
  controlId="floatingInput" 
  label="Confirm Your Password"
  className="mb-3 border border-dark d-inline-block w-100">
    <Form.Control 
    style={styled}
    type="password" 
    placeholder="Confirm Your Password" onChange={(e) => setUserInfo({... userInfo, passConfirm:e.target.value})}/>
  </FloatingLabel>
  <FloatingLabel 
  controlId="floatingInput" 
  label="Phone"
  className="mb-3 border border-dark d-inline-block w-100">
    <Form.Control 
    style={styled}
    type="number" 
    placeholder="Phone" onChange={(e) => setUserInfo({... userInfo, phone: e.target.value})}/>
  </FloatingLabel>
  <FloatingLabel
    controlId="floatingInput"
    label="Email address"
    className="mb-3 border border-dark d-inline-block w-100"
  >
    <Form.Control 
    style={styled}type="email" placeholder="name@example.com" onChange={(e) => setUserInfo({... userInfo, mail:e.target.value})}/>
  </FloatingLabel>
  <FloatingLabel
    controlId="floatingInput"
    label="Address"
    className="mb-3 border border-dark d-inline-block w-100"
  >
    <Form.Control 
    style={styled}type="text" placeholder="Address" onChange={(e) => setUserInfo({... userInfo, address:e.target.value})}/>
  </FloatingLabel>
  <FloatingLabel 
  controlId="floatingInput" 
  label="ZIP Code"
  className="mb-3 border border-dark d-inline-block w-100">
    <Form.Control 
    style={styled}
    type="text" 
    placeholder="ZIP Code" onChange={(e) => setUserInfo({... userInfo, zip:e.target.value})}/>
  </FloatingLabel>
  <br/>
  <Button className="w-100 py-3 mb-3" variant="secondary" type="submit">
    create account
  </Button>
    </Form>
    </Col>
    <Col md={5} className="d-flex flex-column align-items-center ">
  <Button className="w-100 p-3 fs-5 mb-3 d-flex justify-content-evenly align-items-center" variant="secondary" >
  <FaGoogle style={{width:"30px", marginLeft:"3px"}}/> <h5 className='w-75 text-center'>continue with google</h5>
  </Button>
    <Button className="w-100 p-3 fs-5 mb-3 d-flex justify-content-evenly align-items-center" variant="secondary" >
      <FaFacebookF style={{width:"30px", marginLeft:"3px"}}/> <h5 className='w-75 text-center'> continue with facebook</h5>
  </Button>
  <Button className="w-100 p-3 fs-5 mb-3 d-flex justify-content-evenly align-items-center" variant="secondary" >
  <FaApple style={{width:"30px", marginLeft:"3px"}}/> <h5 className='w-75 text-center'>continue with apple</h5>
  </Button>
      <small>already have an acount <Link className='ms-1' to='/login'>login</Link></small>
    </Col>
    </Row>
    </Container>
        </div>
    )
}

export default Register
